<template>
  <div class="wrapper-box">
    <web-header></web-header>
    <web-slide :data="data"></web-slide>
    <web-content></web-content>
    <web-parallax></web-parallax>
    <web-footer></web-footer>
    <web-arrow-up></web-arrow-up>
  </div>
</template>
<script>
import header from '@/components/header'
import slide from '@/components/slide'
import content from '@/components/content'
import parallax from '@/components/parallax'
import footer from '@/components/footer'
import arrowUp from '@/components/arrowUp.vue'

export default {
  name: 'home',
  data() {
    return {
      data: [{
        html: ' <h1><span>BIENVENIDOS A</span><br>  NELSONI RANCH </h1><p> Nos renovamos, apostando al cambio y a la evoluci&oacute;n permanente </p>',
        className: "banner1",
        link:{
          href:'nosotros',
          text:'Conocé nuestra historia'
        }
      },
      {
        html: '<h1><span>NUTRITIVAS PASTURAS<br> CURADAS AL SOL</h1><p>Las pasturas como el Heno y la Alfalfa <br>son la base nutricional de los roedores tales como<br> cobayos, conejos, chinchillas, hamsters, gerbos, etc. </p>',
        className: "banner2",
        link:{
          href:'productos',
          text:'VER PRODUCTOS'
        }

      },
      {
        html: ' <h1>MARLO PARA GATOS</h1><p>Biodegradable, súper absorbente y elimina olores.Además es ultra liviano facilitando la limpieza y el descarte. </p>',
        className: "banner3",
        link:{
          href:'productos',
          text:'VER PRODUCTOS'
        }

      }]
    }
  },
  components: {
    'webHeader': header,
    'webSlide': slide,
    'webContent': content,
    'webParallax': parallax,
    'webFooter': footer,
    'webArrowUp': arrowUp
  }
}
</script>
<style lang="scss">
.wrapper-box {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue